// extracted by mini-css-extract-plugin
module.exports = {"naranjaGramos":"#d46827","rojoGramos":"#e33613","amarilloGramos":"#d89c29","grisGramos":"#4d4d4d","verdeGramos":"#4e833c"};